import React from 'react'

export default function CodeAsset (props) {
  return (
    <svg
      width="149"
      height="106"
      viewBox="0 0 149 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
      aria-hidden="true"
    >
      <rect
        x="-1"
        y="-1"
        width="91.2918"
        height="117.838"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.457 91.2918)"
        stroke="#1D1F21"
        strokeWidth="2"
      />
      <rect
        width="94.0503"
        height="119.838"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 119.838 105.427)"
        fill="#1D1F21"
      />
      <line
        x1="10.8662"
        y1="24.5137"
        x2="70.7853"
        y2="24.5137"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="10.8662"
        y1="35.2261"
        x2="40.4465"
        y2="35.2261"
        stroke="#5CEBA0"
        strokeWidth="2"
      />
      <line
        x1="44.239"
        y1="35.2261"
        x2="57.8915"
        y2="35.2261"
        stroke="#FCE969"
        strokeWidth="2"
      />
      <line
        x1="10.8662"
        y1="45.9389"
        x2="63.9591"
        y2="45.9389"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="10.8662"
        y1="67.3637"
        x2="35.1372"
        y2="67.3637"
        stroke="#FCE969"
        strokeWidth="2"
      />
      <line
        x1="38.9297"
        y1="67.3637"
        x2="57.133"
        y2="67.3637"
        stroke="#5CEBA0"
        strokeWidth="2"
      />
      <line
        x1="10.8662"
        y1="78.076"
        x2="50.3066"
        y2="78.076"
        stroke="#FD7A7D"
        strokeWidth="2"
      />
      <line
        x1="10.8662"
        y1="56.6512"
        x2="52.5821"
        y2="56.6512"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="10.8662"
        y1="89.4185"
        x2="38.1711"
        y2="89.4185"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="41.9634"
        y1="89.4185"
        x2="57.1328"
        y2="89.4185"
        stroke="#5CEBA0"
        strokeWidth="2"
      />
      <rect
        x="81.0016"
        y="26.8821"
        width="67.5038"
        height="34.1311"
        fill="#61C9D7"
      />
      <path
        d="M104.514 36.7424L90.8616 44.3271L104.514 51.9118"
        stroke="#1D1F21"
        strokeWidth="2"
      />
      <path
        d="M123.476 51.9118L137.128 44.3271L123.476 36.7424"
        stroke="#1D1F21"
        strokeWidth="2"
      />
      <path
        d="M118.546 33.7085L110.582 54.9457"
        stroke="#1D1F21"
        strokeWidth="2"
      />
    </svg>
  )
}
